import React, { Component } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { getAppSettings, getLinkPageData, getAllCustomMenuLinks, getInfluencerHelpPopupData } from './../actions/appSettingsActions'
import { trackReferralVisit } from '../actions/referralActions'
import { getUserInfluencerHelpPopupData } from './../actions/userInfluencerHelpAction'
import { getModelDetails, getUserDetails, checkEmailUserToken, setShowLandingPopup } from './../actions/authActions'
import setAuthToken from '../utils/setAuthToken'
import LandingPopup from './landing-popup/LandingPopup'

const MyraidProFont = styled.div`
    font-family: ${props => props.fontFamily};
`

class Startup extends Component {
    constructor() {
        super()

        this.state = {
            isBackgroundSet: false
        }

        this.onLandingPopupClose = this.onLandingPopupClose.bind(this)
    }

    async componentDidMount() {
        const userAuthToken = localStorage.getItem('AuthToken')
        const params = new URLSearchParams(window.location.search)
        const token = params.get('authentication')
        if (token !== null) {
            params.delete('authentication')
            const newUrl =
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                '?' +
                params.toString()
            if (newUrl.endsWith('?')) {
                const cleanedUrl = newUrl.slice(0, -1) // remove the last character
                window.history.replaceState({}, document.title, cleanedUrl)
            } else {
                window.history.replaceState({}, document.title, newUrl)
            }
        }
        if (_.isEmpty(userAuthToken) === true && token !== null) {
            setAuthToken(token)
            await this.props.checkEmailUserToken()
        }
        const urlParams = new URLSearchParams(window.location.search)
        const coupon = urlParams.get('coupon')
        if (coupon) {
            localStorage.setItem('coupon', coupon)
        }

        const referral = params.get('ffr')
        if (referral) {
            const newUrl = window.location.pathname
            window.history.replaceState({}, "", newUrl)
            const updatedReferral = referral.toLowerCase().replace(/\s+/g, "_")
            localStorage.setItem('referral', updatedReferral)
            if (_.isEmpty(userAuthToken) === true && token === null) {
                this.props.trackReferralVisit(referral)
            }
            this.props.setShowLandingPopup(true)
        }
        
        this.props.getUserDetails(() => {
            this.props.getAppSettings(() => {
                if (this.props.auth.appSettings.influencer_help_enabled === true && this.props.auth.isAdmin === true && this.props.auth.isSupport === false) {
                    this.props.getInfluencerHelpPopupData(() => {
                    })
                }
                if (this.props.auth.appSettings.user_influencer_help_enabled === true && this.props.auth.user.isAdmin === false) {
                    this.props.getUserInfluencerHelpPopupData(() => {
                    })
                }
            })
        })
        this.props.getModelDetails()
        this.props.getAllCustomMenuLinks(() => { })
        this.props.getLinkPageData()
    }

    componentDidUpdate() {
        if (this.props.auth.isReady === true && this.state.isBackgroundSet === false) {
            this.setFavicon()
            this.setBackground()
            this.setState({ isBackgroundSet: true })
        }

        if (this.props.auth.appSettings.show_landing_popup_without_referral_link && this.props.auth.showLandingPopup === false && !this.props.auth.landingPopupViewed) {
            this.props.setShowLandingPopup(true)
        }
    }

    setFavicon() {
        const { model_id } = this.props.auth.appSettings
        if (this.props.chat.userProfileInfo[model_id] !== undefined) {
            let favicon = document.getElementById('favicon')
            favicon.href = this.props.chat.userProfileInfo[model_id].profile
        }
    }

    setBackground() {
        const { use_background_image, theme_background_image, site_background_color } = this.props.auth.appSettings

        if (use_background_image && theme_background_image !== '') {
            document.body.style = `background: url(${theme_background_image}); background-size: 'contain';`
        } else {
            document.body.style = `background: ${site_background_color};`
        }
    }

    onLandingPopupClose() {
        this.props.setShowLandingPopup(false)
    }

    render() {
        const {
            isAuthenticated,
            appSettings,
            isBlocked,
            isReady,
            isProfileReady,
            showLandingPopup
        } = this.props.auth
        const { font_family, show_landing_popup, landing_popup_html_link, show_age_modal } = appSettings
        const { isAgeModalOpen } = this.props.utility

        if (isBlocked) {
            return (
                <div className='container'>
                    <div className='row'>
                        <div className='col'>
                            <h3><center>This website is blocked in your area.</center></h3>
                        </div>
                    </div>
                </div>
            )
        }

        return isReady && isProfileReady && this.props.socket.isSocketInitialyConnected === true
            ? <MyraidProFont fontFamily={font_family}>
                {!isAuthenticated && !(isAgeModalOpen && show_age_modal) && showLandingPopup && show_landing_popup &&
                    <LandingPopup
                        url={landing_popup_html_link}
                        onClose={this.onLandingPopupClose}
                    />
                }
                {this.props.children}
            </MyraidProFont>
            : (<></>)
    }
}

Startup.propTypes = {
    auth: PropTypes.object,
    chat: PropTypes.object,
    children: PropTypes.object,
    utility: PropTypes.object.isRequired,
    getAppSettings: PropTypes.func.isRequired,
    getModelDetails: PropTypes.func.isRequired,
    getUserDetails: PropTypes.func.isRequired,
    getAllCustomMenuLinks: PropTypes.func.isRequired,
    getInfluencerHelpPopupData: PropTypes.func.isRequired,
    socket: PropTypes.object,
    getLinkPageData: PropTypes.func.isRequired,
    getUserInfluencerHelpPopupData: PropTypes.func.isRequired,
    checkEmailUserToken: PropTypes.func.isRequired,
    setShowLandingPopup: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors,
    chat: state.chat,
    socket: state.socket,
    utility: state.utility
})

export default connect(
    mapStateToProps,
    {
        getAppSettings,
        getModelDetails,
        getUserDetails,
        getAllCustomMenuLinks,
        getInfluencerHelpPopupData,
        getLinkPageData,
        getUserInfluencerHelpPopupData,
        getUserInfluencerHelpPopupData,
        checkEmailUserToken,
        trackReferralVisit,
        setShowLandingPopup
    }
)(Startup)
